module.exports = "/img/_/_/_/assets/images/creeper/book/common//43.jpg?371ab24cc63b41a85c9ce6506ea77b55";